import {NgModule} from '@angular/core';
import {NoSpacesDirective} from './no-spaces.directive';
import {SelectPlaceholderDirective} from './select-placeholder.directive';

@NgModule({
  declarations: [NoSpacesDirective, SelectPlaceholderDirective],
  exports: [NoSpacesDirective, SelectPlaceholderDirective]
})
export class InputRestrictionsModule {
}
